import { gql } from '~src/generated/portal/gql';

const CREATE_API_TEST_PLAN = gql(`
  mutation createAPITestPlan($input: CreateAPITestPlanInput!) {
    createAPITestPlan(input: $input) {
      id
      name
      description
      partnerId
      providerId
      minApiVersion {
        version
      }
      platform {
        platform
      }
      environment
    }
  }
`);
export default CREATE_API_TEST_PLAN;
